// Espejo del backend. La gestión completa se ofrece desde Ajustes;
// el wizard solo necesita codigo y capacidad como compatibilidad mínima.

import { z } from 'zod';

// Mismo regex que camada.codigo_lote (decisión 10 del ADR-021).
// Aquí es para el codigo de la nave: "N1", "Nave-Norte", etc.
// El guion al final del character class no necesita escape.
const CODIGO_NAVE_REGEX = /^[A-Za-z0-9-]{1,50}$/;

export const naveCreateSchema = z.object({
  codigo: z
    .string()
    .min(1, 'nave.error_codigo_formato')
    .max(50, 'nave.error_codigo_formato')
    .regex(CODIGO_NAVE_REGEX, 'nave.error_codigo_formato'),
  nombre: z.string().trim().max(100, 'nave.error_nombre').nullable().default(null),
  superficie_m2: z.number().positive('nave.error_superficie_no_positiva').nullable().default(null),
  capacidad_animales: z
    .number()
    .int('nave.error_capacidad_no_entera')
    .positive('nave.error_capacidad_no_positiva')
    .nullable()
    .default(null),
  tipo_ventilacion: z.string().max(100, 'nave.error_ventilacion').nullable().default(null),
  observaciones: z.string().nullable().default(null),
  fecha_alta: z.string().nullable().default(null),
});

export type NaveCreateFormValues = z.infer<typeof naveCreateSchema>;
export const naveUpdateSchema = naveCreateSchema.extend({ nombre: z.string().trim().min(1) });
export type NaveUpdateFormValues = z.infer<typeof naveUpdateSchema>;
